import { NavigateFunction } from 'react-router-dom';
import { RoutePaths, RoutesPathNames } from 'app/routing';
import {
  ButtonsTabType,
  DURATION_LIST,
  INDUSTRY_LIST,
  JobOpeningFormStepType,
  ORGANIZATION_SIZE_TYPE,
  profileScoreDetailsInfoType,
  SALARY_PERIOD_TYPE,
  SelectedFilterElementsType,
  STARTING_CONDITION_TYPE,
  VacancyErrorsTypes,
} from 'models/commonTypes';
import {
  DASHBOARD_TABS_ID,
  DURATION_LIST_ENUMS,
  FILTER_BOOLEAN_ID,
  FILTER_TYPE,
  INDUSTRY_LIST_ENUMS,
  NOTIFICATION_PREFERENCE,
  ORGANIZATION_SIZE,
  SALARY_PERIOD_ENUMS,
  SIGN_UP_STEP_WITH_USER_EXPERIENCE,
  STARTING_CONDITION_ENUMS,
  VACANCY_APPLICATION_STATUS,
  VACANCY_STATUS,
} from 'models/enums';
import { GasStationToggle, ShipToggle, WindMillToggle } from 'icons/IndustryToggleIcons';
import { OneTermToggle, PermanentToggle, TemporaryToggle } from 'icons/DurationToggleIcons';
import BusinessCenterIcon from 'icons/BusinessCenterIcon';
import AccountCircleIcon from 'icons/AccountCircleIcon';
import ArticleIcon from 'icons/ArticleIcon';
import SchoolIcon from 'icons/SchoolIcon';
import ContactPageIcon from 'icons/ContactPageIcon';

export const GET_MOCK_VESSEL = (id: string) => ({
  id,
  imo: 1006257,
  name: 'SAWASDEE SINGAPORE',
  grossTonnage: 15859,
  operatorName: 'Lorem',
  kind: {
    id: '25769803776',
    name: 'Container Ship',
    perma: '1',
  },
  length: 467,
  image: 'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
  cnISO: 'KR',
  countryName: 'South Korea',
});

export const MOCK_STARTING_CONDITION: Array<STARTING_CONDITION_TYPE> = [
  { name: 'Immediately', id: STARTING_CONDITION_ENUMS.IMMEDIATELY },
  { name: 'Continuously', id: STARTING_CONDITION_ENUMS.CONTINUOUSLY },
  { name: 'Date', id: STARTING_CONDITION_ENUMS.DATE },
];

export const MOCK_ORGANIZATION_SIZE_WITH_LABEL: Array<ORGANIZATION_SIZE_TYPE> = [
  { name: '1-10 employees', id: ORGANIZATION_SIZE.SIZE_1_10 },
  { name: '10-50 employees', id: ORGANIZATION_SIZE.SIZE_11_50 },
  { name: '50-200 employees', id: ORGANIZATION_SIZE.SIZE_51_200 },
  { name: '200-500 employees', id: ORGANIZATION_SIZE.SIZE_201_500 },
  { name: '500-1000 employees', id: ORGANIZATION_SIZE.SIZE_501_1000 },
  { name: 'More than 1000 employees', id: ORGANIZATION_SIZE.SIZE_MORE_1000 },
];

export const MOCK_ORGANIZATION_SIZE: Array<ORGANIZATION_SIZE_TYPE> = [
  { name: '1-10', id: ORGANIZATION_SIZE.SIZE_1_10 },
  { name: '10-50', id: ORGANIZATION_SIZE.SIZE_11_50 },
  { name: '50-200', id: ORGANIZATION_SIZE.SIZE_51_200 },
  { name: '200-500', id: ORGANIZATION_SIZE.SIZE_201_500 },
  { name: '500-1000', id: ORGANIZATION_SIZE.SIZE_501_1000 },
  { name: 'More than 1000', id: ORGANIZATION_SIZE.SIZE_MORE_1000 },
];

export const MOCK_VESSEL_KINDS = [
  { id: '42949673085', name: 'Forest-product carrier', perma: '126' },
  { id: '42949673020', name: 'General cargo vessel', perma: '61' },
  { id: '42949673084', name: 'Transport ship', perma: '125' },
  { id: '42949673039', name: 'LPG tanker', perma: '80' },
  { id: '42949672982', name: 'Factory ship', perma: '23' },
];

export const MOCK_DOCUMENT = {
  id: '55834574871',
  urls: [
    'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
    'https://photos.fleetmon.com/vessels/vb-asdrubal_9245811_718325_XLarge.jpg',
    'https://photos.fleetmon.com/vessels/aaa_9265720_748253_XLarge.jpg',
  ],
  xlarge_urls: [
    'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
    'https://photos.fleetmon.com/vessels/vb-asdrubal_9245811_718325_XLarge.jpg',
    'https://photos.fleetmon.com/vessels/aaa_9265720_748253_XLarge.jpg',
  ],
  kind: MOCK_VESSEL_KINDS[0],
};

export const MOCK_AVATAR =
  'data:image/jpeg;base64,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';

export const PROFILE_CERTIFICATE_MOCK_DATA = [
  {
    id: '001',
    name: 'Fit To Train Assessment (For In Water CA-EBS)',
    alts: ['VI/2, п. 1, А-VI/2, п.1-4'],
    kind: null,
    neverExpires: false,
  },
  {
    id: '002',
    name: 'Escapte Chute Certificate',
    alts: ['VI/1, A-VI/1, п.1-2'],
    kind: null,
    neverExpires: true,
  },
  {
    id: '003',
    name: 'Rescue boats Security',
    alts: ['A-VI/1, п.1-2'],
    neverExpires: false,
    kind: {
      id: '8586634512',
      name: 'Security',
      perma: '00031',
    },
  },
  {
    id: '004',
    name: 'Proficiency in survival craft equipment',
    alts: ['OPITO Control Room Operator Emergency Response Competence Assessment and Coaching'],
    neverExpires: false,
    kind: {
      id: '8579934545',
      name: 'STCW',
      perma: '00041',
    },
  },
  {
    id: '005',
    name: 'Coc second Engineer, within 200 nautical mile',
    alts: ['STCW III/2', 'Coc Chief mate Contr. Material/ supply vessels', 'tugs 3000 GT or more or within 200 nautical mile'],
    neverExpires: false,
    kind: {
      id: '8589934593',
      name: 'STCW',
      perma: '00051',
    },
  },
  {
    id: '006',
    name: 'IWCF Drilling Well Control Level 3',
    alts: ['VI/1'],
    kind: {
      id: '8589954592',
      name: 'Security',
      perma: '00061',
    },
  },
  {
    id: '007',
    name: 'ECITB Mechanical Joint Integrity (MJI10 & MJI19)',
    alts: ['VI/1'],
    kind: {
      id: '8589734592',
      name: 'Security',
      perma: '00071',
    },
  },
];

export const CERTIFICATES_WITH_ALL_ICONS = [
  ...PROFILE_CERTIFICATE_MOCK_DATA,
  {
    id: '112',
    name: 'Proficiency in other items',
    alts: ['VI/1, A-VI/1, п.1-2'],
    kind: {
      id: '8389934512',
      name: 'Offshore Wind',
      perma: '01121',
    },
  },
  {
    id: '113',
    name: 'Rescue boats Security',
    alts: ['A-VI/1, п.1-2'],
    kind: {
      id: '8589934612',
      name: 'Offshore Oil & Gas',
      perma: '01131',
    },
  },
  {
    id: '114',
    name: 'CoC Chief mate all ship',
    alts: ['VI/1, A-VI/1, п.1-2'],
    kind: {
      id: '8589934346',
      name: 'Flag State Document',
      perma: '01141',
    },
  },
  {
    id: '115',
    name: 'United Kingdom seamansbook',
    alts: ['VI/1'],
    kind: {
      id: '8589937545',
      name: 'Offshore',
      perma: '01151',
    },
  },
];

export const initialListOfCountries = [
  { id: '8589934805', isoCode: 'SZ', name: 'Swaziland' },
  { id: '8589934809', isoCode: 'TW', name: 'Taiwan' },
  { id: '8589934738', isoCode: 'MC', name: 'Monaco' },
  { id: '8589934721', isoCode: 'LU', name: 'Luxembourg' },
  { id: '8589934701', isoCode: 'IT', name: 'Italy' },
];

export const initialListOfHiringAreas = [
  { id: '107374182412', name: 'Bering Sea and Strait', perma: '13' },
  { id: '107374182414', name: 'South China Sea', perma: '15' },
  { id: '107374182423', name: 'Hudson Bay', perma: '24' },
  { id: '107374182401', name: 'Mediterranean Sea', perma: '2' },
  { id: '107374182403', name: 'Aral Sea', perma: '4' },
];

export const initialListOfActivities = [
  {
    id: '1',
    label: 'drilling',
    perma: '1',
    timesUsed: 0,
  },
  {
    id: '2',
    label: 'Oil',
    perma: '2',
    timesUsed: 0,
  },
  {
    id: '3',
    label: 'Custom tag',
    perma: '3',
    timesUsed: 0,
  },
];

export const DUTIES_MOCK = [
  {
    id: '17179869207',
    name: 'AB/OS',
    perma: '24',
    alts: [''],
  },
  {
    id: '17179869204',
    name: 'BOSUN',
    perma: '21',
    alts: ['B.O.S.U.N.'],
  },
  {
    id: '17179869287',
    name: 'Dredge Master',
    perma: '104',
    alts: [''],
  },
];

export const MOCK_SINGLE_DUTY = DUTIES_MOCK[0];

export const SEA_SERVICE_MOCK_DATA = [
  {
    id: '10000000-2222-0000-0000-000001001100',
    start: '2011-11-18',
    end: '2012-02-04',
    rotations: 1,
    description: '',
    vessel: {
      id: '98784247924',
      imo: 7313652,
      name: 'EXCELLENCE',
      grossTonnage: 5413,
      operatorName: 'AJVS INC.',
      kind: {
        id: '25769803775',
        name: 'Research Vessel',
        perma: '1',
      },
      length: 112,
      image: 'https://photos.fleetmon.com/vessels/excellence_7313652_1086463_XLarge.jpg',
      cnISO: 'US',
      countryName: 'United State',
    },
    duty: DUTIES_MOCK[0],
    note: '',
    activities: [
      {
        id: '4294967300',
        label: 'my tag',
        perma: '',
        timesUsed: 0,
      },
      {
        id: '4294967302',
        label: 'oli',
        perma: '',
        timesUsed: 0,
      },
    ],
  },
  {
    id: '20000000-2222-0000-0000-000000000000',
    start: '2010-11-18',
    end: '2015-06-04',
    rotations: 10,
    description: '',
    vessel: {
      id: '98784247922',
      imo: 1006257,
      name: 'SAWASDEE SINGAPORE',
      grossTonnage: 15859,
      operatorName: 'Lorem',
      kind: {
        id: '25769803776',
        name: 'Container Ship',
        perma: '1',
      },
      length: 467,
      image: 'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
      cnISO: 'KR',
      countryName: 'South Korea',
    },
    duty: {
      id: '17179869184',
      name: 'Master',
      perma: '2',
    },
    activities: [
      {
        id: '4294967301',
        label: 'drilling',
        perma: '',
        timesUsed: 0,
      },
      {
        id: '4294967302',
        label: 'oli',
        perma: '',
        timesUsed: 0,
      },
    ],
  },
];

export const VESSELS_DATA_MOCKS = [
  {
    fleetmonID: '1262',
    imo: 9081021,
    name: 'SOVEREIGNTY',
    image: 'https://photos.fleetmon.com/vessels/vb-asdrubal_9245811_718325_XLarge.jpg',
    operatorName: 'Trident Seafoods Corp',
    kind: {
      id: '42949673087',
      name: 'Fishing vessel',
      perma: '97',
    },
    length: 15,
    countryName: 'China',
    cnISO: 'CN',
    grossTonnage: 45681,
  },
  {
    fleetmonID: '11386',
    imo: 9120841,
    name: 'SOVEREIGN MAERSK',
    image: 'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
    operatorName: 'Moller-Maersk A/S',
    kind: {
      id: '42949673025',
      name: 'Container ship',
      perma: '35',
    },
    length: 300,
    countryName: 'Netherlands',
    cnISO: 'NL',
    grossTonnage: 15897,
  },
  {
    fleetmonID: '16925',
    imo: 9390460,
    name: 'RAMFORM SOVEREIGN',
    image: 'https://photos.fleetmon.com/vessels/aaa_9265720_748253_XLarge.jpg',
    operatorName: 'Ocean Marine Services Inc',
    kind: {
      id: '42949673053',
      name: 'Geophysical survey',
      perma: '63',
    },
    length: 240,
    countryName: 'Costa Rica',
    cnISO: 'CR',
    grossTonnage: 995412,
  },
  {
    fleetmonID: '13456',
    imo: 0,
    name: 'RAMFORM',
    image: 'https://photos.fleetmon.com/vessels/aaa_9265720_748253_XLarge.jpg',
    operatorName: 'Ocean Marine Services Inc',
    kind: {
      id: '42949673041',
      name: 'Research ship',
      perma: '51',
    },
    length: 240,
    countryName: 'Canada',
    cnISO: 'CA',
    grossTonnage: 56741,
  },
  {
    fleetmonID: '13457',
    imo: 0,
    name: 'RAMFORM SUPER',
    image: 'https://photos.fleetmon.com/vessels/aaa_9265720_748253_XLarge.jpg',
    operatorName: 'Ocean Marine Services Inc',
    kind: {
      id: '42949673097',
      name: 'Platform supply vessel',
      perma: '107',
    },
    length: 235,
    countryName: 'Bolivia',
    cnISO: 'BO',
    grossTonnage: 456874,
  },
];

export const TAGS_MOCK = [
  { id: '1', label: 'Oil Rig' },
  { id: '2', label: 'Drilling' },
  { id: '3', label: 'Offshore Wind Construction' },
];

export const DETAILS_VESSELS_DATA_MOCKS = {
  deadWeight: 20156,
  grossTonnage: 15859,
  imageURL: 'https://photos.fleetmon.com/vessels/sawasdee-singapore_9081021_1073039_XLarge.jpg',
  imoNumber: 9081021,
  length: 167,
  manager: '',
  name: 'SAWASDEE SINGAPORE',
  owner: 'Offen Claus-Peter Reederei',
  vesselType: 'Container ship',
  width: 28,
  cnISO: 'FR',
  kind: MOCK_VESSEL_KINDS[1],
};

export const EDUCATIONS_MOCK_DATA = [
  {
    id: '30000000-0000-0000-0000-000000000000',
    start: '2011-11-18',
    end: '2012-02-04',
    name: 'Education 1',
    kind: {
      id: '25769803778',
      name: 'Secondary School',
      perma: '3',
    },
  },
  {
    id: '30000000-0000-0000-0000-000000000001',
    start: '2011-11-18',
    end: '2012-02-04',
    name: 'Education 2',
    kind: {
      id: '25769803788',
      name: 'University',
      perma: '13',
    },
  },
];

export const EDUCATION_KINDS_MOCK_DATA = [
  {
    id: '25769803776',
    name: 'Kindergarten',
    perma: '1',
  },
  {
    id: '25769803779',
    name: 'Tertiary School',
    perma: '4',
  },
  {
    id: '25769803781',
    name: 'Quinary School',
    perma: '6',
  },
  {
    id: '25769803782',
    name: 'Senary School',
    perma: '7',
  },
  {
    id: '25769803786',
    name: 'Denary School',
    perma: '11',
  },
];

export const CERTIFICATE_INFOS_WITH_EXPIRY_DATE = [
  {
    id: '101',
    expires: '2011-11-18',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[0],
    document: null,
  },
  {
    id: '102',
    expires: '2015-5-23',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[1],
    document: null,
  },
  {
    id: '103',
    expires: '2010-2-14',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[2],
    document: null,
  },
  {
    id: '104',
    expires: '2019-12-21',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[3],
    document: null,
  },
  {
    id: '105',
    expires: '2013-9-25',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[4],
    document: null,
  },
  {
    id: '106',
    expires: '2016-5-13',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[5],
    document: null,
  },
  {
    id: '107',
    expires: '2017-7-17',
    owner: {
      id: '1',
    },
    certificate: PROFILE_CERTIFICATE_MOCK_DATA[6],
    document: null,
  },
];

export const CERTIFICATE_INFOS_WITH_PRIORITY_DATE = CERTIFICATE_INFOS_WITH_EXPIRY_DATE.map((certificate, index) => {
  const priority = index % 2 === 0 ? 1 : 0;
  return { ...certificate, certificate: { ...certificate.certificate, priority } };
});

export const CERTIFICATE_INFOS_BY_DEFAULT = CERTIFICATE_INFOS_WITH_EXPIRY_DATE.map(certificate => ({ ...certificate, expires: null }));

export const CERTIFICATE_INFOS_WITH_DOCUMENT = CERTIFICATE_INFOS_WITH_EXPIRY_DATE.map(certificate => ({
  ...certificate,
  document: { id: '1547845214', urls: [MOCK_DOCUMENT.urls[1]], xlarge_urls: [MOCK_DOCUMENT.xlarge_urls[1]] },
}));

export const CERTIFICATE_INFOS_RANDOM_EXPIRED_DATE = CERTIFICATE_INFOS_WITH_EXPIRY_DATE.map((certificate, i) => {
  if (i === 0) return { ...certificate, expires: null };
  return !!(i % 2) ? { ...certificate } : { ...certificate, expires: `202${3 + i}-7-17` };
});

export const CERTIFICATE_INFOS_DIFFERENT_EXPIRE_DATE = CERTIFICATE_INFOS_WITH_DOCUMENT.map((certificate, i) => {
  return !!(i % 2) ? { ...certificate, expires: `201${3 + i}-04-15` } : { ...certificate, expires: `202${3 + i}-7-17` };
});

export const CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE = [
  ...CERTIFICATE_INFOS_WITH_EXPIRY_DATE,
  {
    id: '1110',
    expires: '2014-3-11',
    owner: {
      id: '1',
    },
    certificate: CERTIFICATES_WITH_ALL_ICONS[7],
    document: null,
  },
  {
    id: '1111',
    expires: null,
    owner: {
      id: '1',
    },
    certificate: CERTIFICATES_WITH_ALL_ICONS[8],
    document: null,
  },
  {
    id: '1112',
    expires: '2012-3-15',
    owner: {
      id: '1',
    },
    certificate: CERTIFICATES_WITH_ALL_ICONS[9],
    document: null,
  },
  {
    id: '1113',
    expires: null,
    owner: {
      id: '1',
    },
    certificate: CERTIFICATES_WITH_ALL_ICONS[10],
    document: null,
  },
];

export const ALL_EDUCATIONS_MOCK_DATA = [
  {
    id: '30000000-0000-0000-0000-000000000014',
    start: '2011-11-18',
    end: '2012-02-04',
    name: 'Secondary School',
    kind: {
      id: '25769803783',
      name: 'Tertiary School',
      perma: '4',
    },
  },
  {
    id: '30000000-0000-0000-0000-000000000011',
    start: '2021-11-18',
    end: '2022-02-04',
    name: 'Kindergarten',
    kind: {
      id: '25769803777',
      name: 'Kindergarten',
      perma: '1',
    },
  },
  {
    id: '30000000-0000-0000-0000-000000000012',
    start: '2011-11-18',
    end: '2012-02-04',
    name: 'Primary School',
    kind: {
      id: '25769803787',
      name: 'Primary School',
      perma: '2',
    },
  },
  {
    id: '30000000-0000-0000-0000-000000000013',
    start: '2021-11-18',
    end: '2022-02-04',
    name: 'Secondary School',
    kind: {
      id: '25769803782',
      name: 'Secondary School',
      perma: '3',
    },
  },
  ...EDUCATIONS_MOCK_DATA,
];

export const EDUCATION_CONNECTION = ALL_EDUCATIONS_MOCK_DATA.map((education, index) => ({
  node: {
    ...education,
    name: index % 2 !== 0 ? education.name : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been',
    end: index % 2 === 0 ? education.end : null,
  },
}));

export const SEA_SERVICE_CONNECTION = SEA_SERVICE_MOCK_DATA.map(seaService => ({
  node: {
    ...seaService,
  },
}));
export const MANY_SEA_SERVICES = [
  ...SEA_SERVICE_MOCK_DATA.map((service, index) => ({ ...service, id: service.id + index })),
  ...SEA_SERVICE_MOCK_DATA.map((service, index) => ({ ...service, id: service.id + index + index })),
  ...SEA_SERVICE_MOCK_DATA.map((service, index) => ({ ...service, id: service.id + index + index + index })),
];

export const MOCK_ORGANIZATION_PROFILE_MEMBERSHIP = [
  {
    id: '94489280512',
    createdAt: '2023-02-16T13:41:49.429135Z',
    role: 'owner',
    organization: {
      id: '90194313216',
      name: 'TOS',
      description: 'My new test2 company',
      avatarUrl: 'https:///uploads.crewlinker.com/avatars/07b76f0f5fb364376bac9ae62d230cff_xs.png',
      size: ORGANIZATION_SIZE.SIZE_201_500,
    },
  },
  {
    id: '94489280860',
    createdAt: '2023-08-01T11:41:21.915162Z',
    role: 'member',
    organization: {
      id: '90194313501',
      name: 'React Company',
      description: '1233332123123 ',
      avatarUrl: 'https:///uploads.crewlinker.com/avatars/93fc8b6b6f19d3c74d282c71ba36cee6_xs.png',
      size: ORGANIZATION_SIZE.SIZE_1_10,
    },
  },
  {
    id: '94489280989',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313528',
      name: 'Ship org.',
      description: '',
      avatarUrl: '',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
  {
    id: '94489280990',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313529',
      name: 'GCO',
      description: '',
      avatarUrl: '',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
  {
    id: '94489280991',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'invited',
    organization: {
      id: '90194313530',
      name: 'ZXT',
      description: '',
      avatarUrl: 'https:///uploads.crewlinker.com/avatars/07b76f0f5fb364376bac9ae62d230cff_xs.png',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
  {
    id: '94489280992',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313531',
      name: 'Big Trace',
      description: '',
      avatarUrl: '',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
  {
    id: '94489280993',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313532',
      name: 'Cargo Fast Org.',
      description: '',
      avatarUrl: 'https:///uploads.crewlinker.com/avatars/07b76f0f5fb364376bac9ae62d230cff_xs.png',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },

  {
    id: '94489280994',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313533',
      name: 'Shadow TR',
      description: '',
      avatarUrl: 'https:///uploads.crewlinker.com/avatars/93fc8b6b6f19d3c74d282c71ba36cee6_xs.png',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
  {
    id: '94489280995',
    createdAt: '2023-08-17T10:59:04.352853Z',
    role: 'member',
    organization: {
      id: '90194313534',
      name: 'GTS',
      description: '',
      avatarUrl: '',
      size: ORGANIZATION_SIZE.SIZE_51_200,
    },
  },
];
export const MOCK_PROFILE_DATA = {
  createdAt: '2020-08-18T08:06:56Z',
  info: {
    id: '09876543210',
    firstName: 'Jane',
    lastName: 'Doe',
    birthDate: '1995-10-18',
    avatarUrl: '',
    bio: null,
    primaryDuty: null,
    country: initialListOfCountries[0],
    isHidden: false,
    yearsOfExperience: null,
  },
  owner: {
    id: '3',
    createdAt: '2020-08-18T08:06:56Z',
  },
  notificationPreference: { id: '133143986190', jobOpening: true, tipsToImprove: true },
  seaServicesHighlighted: SEA_SERVICE_MOCK_DATA,
  seaServices: SEA_SERVICE_MOCK_DATA,
  seaServicesAddedCount: SEA_SERVICE_MOCK_DATA.length,
  certificateInfos: CERTIFICATE_INFOS_BY_DEFAULT,
  educations: [],
  membership: [],
  appraisals: [],
  generalSetting: {
    availableForWork: true,
    hideContactInfo: false,
    id: '146028888069',
  },
};

export const MOCK_UPDATED_PROFILE_DATA = {
  createdAt: '2020-08-18T08:06:56Z',
  info: {
    id: '16485324591',
    firstName: 'Update',
    lastName: 'me',
    birthDate: '2000-11-18',
    bio: 'I can be updated and the mock pretends the server returned an error!',
    primaryDuty: MOCK_SINGLE_DUTY,
    avatarUrl: MOCK_AVATAR,
    country: initialListOfCountries[0],
    yearsOfExperience: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_5_10,
  },
  owner: {
    id: '6',
    createdAt: '2020-08-18T08:06:56Z',
  },
  seaServicesHighlighted: [],
  seaServicesAddedCount: [],
  certificateInfos: [],
  educations: [],
  notificationPreference: null,
};

export const MOCK_LIST_OF_APPRAISALS = [
  {
    id: '11100000-1111-0000-0000-000000000000',
    review: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    owner: {
      id: '30064771145',
    },
    seaService: SEA_SERVICE_MOCK_DATA[0],
  },
  {
    id: '11100000-2222-0000-0000-000000000000',
    review: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
    owner: {
      id: '30064771145',
    },
    seaService: SEA_SERVICE_MOCK_DATA[1],
  },
];

export const MOCK_APPRAISALS_WITH_DOCUMENTS = [
  ...MOCK_LIST_OF_APPRAISALS.map((appraisal, index) => ({
    ...appraisal,
    seaService: {
      ...appraisal.seaService,
      end: index % 2 ? appraisal.seaService.end : null,
    },
    document:
      index % 2
        ? {
            urls: ['https://clawssi-uploadsbucket-11va5m3jlet8r.s3.eu-west-1.amazonaws.com/certificates/bda5126cdbcc120bb3c6de751219b5e1_xs.png'],
            xlarge_urls: ['https://clawssi-uploadsbucket-11va5m3jlet8r.s3.eu-west-1.amazonaws.com/certificates/2ba6fc838ee6408a7b8ccbef19593678_original.png'],
          }
        : null,
    id: appraisal.id + index,
  })),
];

export const MOCK_SINGLE_PROFILE = {
  id: '30064771013',
  info: {
    id: '30064771072',
    firstName: 'Megan',
    lastName: 'Huang',
    bio: '',
    birthDate: '1989-06-15T22:00:00Z',
    avatarUrl: 'https://photos.fleetmon.com/vessels/geosea_9242431_94418_XLarge.jpg',
    primaryDuty: DUTIES_MOCK[0],
    owner: {
      id: '30064771013',
      info: {
        firstName: 'Megan',
      },
    },
    country: {
      id: '12884902044',
      isoCode: 'NL',
      name: 'Netherlands',
    },
  },
  educations: ALL_EDUCATIONS_MOCK_DATA,
  appraisals: [...MOCK_LIST_OF_APPRAISALS.map((appraisal, index) => ({ ...appraisal, id: appraisal.id + index }))],
  seaServices: MANY_SEA_SERVICES,
  certificateInfos: CERTIFICATE_INFOS_BY_DEFAULT,
  seaServicesHighlighted: [SEA_SERVICE_MOCK_DATA[0]],
  objectID: '30064771072',
  firstName: 'Megan',
  lastName: 'Huang',
  seaServiceDuties: ['21', '1', '99'],
};

export const MOCK_LIST_OF_PROFILES_SEARCH_NODES = [
  {
    id: '101',
    info: {
      id: '1001',
      primaryDuty: MOCK_SINGLE_DUTY,
      firstName: 'Megan',
      lastName: 'Huang',
      avatarUrl: MOCK_AVATAR,
    },
    membership: MOCK_ORGANIZATION_PROFILE_MEMBERSHIP,
  },
];
export const MOCK_LIST_OF_PROFILES = [
  {
    node: {
      objectID: '30064771072',
      firstName: 'Megan',
      lastName: 'Huang',
      seaServiceDuties: [...DUTIES_MOCK.map(duty => duty.id)],
      birthDate: 631141200,
      certificates: [
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[0].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[2].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[1].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[5].certificate.id,
      ],
      country: initialListOfCountries[1].isoCode,
      seaServiceActivities: [
        initialListOfActivities[0].id,
        initialListOfActivities[1].id,
        initialListOfActivities[2].id,
        initialListOfActivities[1].id,
        initialListOfActivities[2].id,
      ],
      primaryDuty: DUTIES_MOCK[0].id,
      numSeaServices: 4,
      avatarUrl: MOCK_AVATAR,
      availableForWork: true,
    },
  },
  {
    node: {
      objectID: '30064771073',
      firstName: 'Tegan',
      lastName: 'Osborne',
      seaServiceDuties: [DUTIES_MOCK[0].id, DUTIES_MOCK[1].id],
      birthDate: 632241200,
      certificates: [
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[1].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[4].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[7].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[2].certificate.id,
      ],
      primaryDuty: DUTIES_MOCK[2].id,
      country: initialListOfCountries[2].isoCode,
      seaServiceActivities: [initialListOfActivities[1].id, initialListOfActivities[0].id],
      numSeaServices: 3,
      avatarUrl: MOCK_AVATAR,
      availableForWork: false,
    },
  },
  {
    node: {
      objectID: '30064771074',
      firstName: 'Aliyah',
      lastName: 'Bellamy',
      seaServiceDuties: [DUTIES_MOCK[2].id, DUTIES_MOCK[0].id],
      birthDate: 632241300,
      certificates: [
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[1].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[4].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[3].certificate.id,
      ],
      primaryDuty: DUTIES_MOCK[1].id,
      country: initialListOfCountries[4].isoCode,
      seaServiceActivities: [initialListOfActivities[0].id, initialListOfActivities[1].id, initialListOfActivities[2].id],
      numSeaServices: 5,
      avatarUrl: MOCK_AVATAR,
      availableForWork: false,
    },
  },
  {
    node: {
      objectID: '30064771075',
      firstName: 'Aurelia',
      lastName: 'Poole',
      seaServiceDuties: [DUTIES_MOCK[1].id],
      birthDate: 654241300,
      certificates: [],
      primaryDuty: DUTIES_MOCK[0].id,
      country: initialListOfCountries[0].isoCode,
      seaServiceActivities: [initialListOfActivities[2].id, initialListOfActivities[0].id, initialListOfActivities[1].id],
      numSeaServices: 1,
      avatarUrl: MOCK_AVATAR,
      availableForWork: true,
    },
  },
  {
    node: {
      objectID: '30064771076',
      firstName: 'Anne-Marie',
      lastName: 'Mckinney',
      seaServiceDuties: [],
      birthDate: 654245600,
      certificates: [
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[3].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[5].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[1].certificate.id,
        CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE[2].certificate.id,
      ],
      primaryDuty: DUTIES_MOCK[1].id,
      country: initialListOfCountries[3].isoCode,
      seaServiceActivities: [],
      numSeaServices: 4,
      avatarUrl: MOCK_AVATAR,
      availableForWork: true,
    },
  },
];

export const MOCK_DOCUMENT_KINDS = [
  {
    id: '51539607556',
    name: 'Certificate',
    perma: '1',
  },
  {
    id: '51539607558',
    name: 'Document',
    perma: '1234',
  },
];

export const APPRAISALS_CONNECTION = MOCK_LIST_OF_APPRAISALS.map((appraisal, index) => ({
  node: {
    ...appraisal,
    document: {
      id: `5583457509${index}`,
      urls: [MOCK_DOCUMENT.urls[index]],
      xlarge_urls: [[MOCK_DOCUMENT.xlarge_urls[index]]],
    },
  },
}));

export const MOCK_PROFILE_RATING_DETAILS = [
  { name: 'basic_info', filled: false, weight: 10, order: 1 },
  { name: 'one_sea_service', filled: false, weight: 10, order: 2 },
  { name: 'one_certificate', filled: false, weight: 10, order: 3 },
  { name: 'one_education', filled: false, weight: 10, order: 4 },
  { name: 'one_appraisal', filled: false, weight: 10, order: 5 },
  { name: 'all_certs_has_expire_date', filled: false, weight: 10, order: 6 },
  { name: 'all_certs_has_documents', filled: false, weight: 10, order: 7 },
  { name: 'all_certs_not_expired', filled: false, weight: 10, order: 8 },
  { name: 'exists_bio', filled: false, weight: 10, order: 9 },
  { name: 'exists_avatar', filled: false, weight: 10, order: 11 },
];

export function mappingMockProfileRatingDetails(range: number) {
  return [
    ...MOCK_PROFILE_RATING_DETAILS.map((element, index) => {
      if (index > range) {
        return { ...element, filled: true };
      } else {
        return element;
      }
    }),
  ];
}

export const MEMBERSHIP_ORGANIZATION_MOCK = {
  id: '51537834756',
  createdAt: '2022-02-20T11:57:35.879648Z',
  role: 'owner',
  organization: {
    id: '51539608756',
    name: 'Shemship B.V.',
    avatarUrl: 'https://clawssi-uploadsbucket-11va5m3jlet8r.s3.eu-west-1.amazonaws.com/avatars/1fd51a0aedc8be2bf73f4fe2f75e5e96_xs.png',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    size: ORGANIZATION_SIZE.SIZE_201_500,
    websiteUrl: 'test@gmail.com',
    numberOfVacancies: 10,
    country: initialListOfCountries[0],
    city: 'Lausanne',
  },
  profile: null,
};

export const MOCK_LIST_OF_PROFILES_FOR_VACANCY = MOCK_LIST_OF_PROFILES.map(({ node }, index) => ({
  ...MOCK_PROFILE_DATA,
  id: node.objectID,
  info: { ...MOCK_PROFILE_DATA.info, id: `12884901255${index}`, firstName: node.firstName, lastName: node.lastName, avatarUrl: node.avatarUrl, primaryDuty: DUTIES_MOCK[0] },
}));

export const GET_LIST_OF_HIRES = [
  { id: '4587415985', owner: MOCK_LIST_OF_PROFILES_FOR_VACANCY[1] },
  { id: '4587419547', owner: MOCK_LIST_OF_PROFILES_FOR_VACANCY[2] },
  { id: '4588529547', owner: MOCK_LIST_OF_PROFILES_FOR_VACANCY[4] },
];

export const MOCK_ORGANIZATION_MEMBERS = [
  {
    node: {
      id: '5634256077',
      role: 'member',
      profile: {
        id: '5634256078',
        info: {
          firstName: 'Ad Van',
          lastName: 'der Veer',
          avatarUrl: MOCK_AVATAR,
          primaryDuty: DUTIES_MOCK[0],
        },
      },
      organization: {
        id: '5637592000',
        name: 'Company 1',
      },
    },
  },
  {
    node: {
      id: '5634268908',
      role: 'member',
      profile: {
        id: '5634256079',
        info: {
          firstName: 'React',
          lastName: 'TS',
          avatarUrl: null,
          primaryDuty: DUTIES_MOCK[1],
        },
      },
      organization: {
        id: '5637592032',
        name: 'Company 2',
      },
    },
  },
  {
    node: {
      id: '5634294039',
      role: 'member',
      profile: {
        id: '5634256080',
        info: {
          firstName: 'Oleks',
          lastName: 'Serhiienko',
          avatarUrl: MOCK_AVATAR,
          primaryDuty: DUTIES_MOCK[0],
        },
      },
      organization: {
        id: '5637998039',
        name: 'Company 3',
      },
    },
  },
  {
    node: {
      id: '5634556039',
      role: 'member',
      profile: {
        id: '5634256081',
        info: {
          firstName: 'Illia',
          lastName: 'Sobko',
          avatarUrl: null,
          primaryDuty: DUTIES_MOCK[2],
        },
      },
      organization: {
        id: '5637443039',
        name: 'Company 4',
      },
    },
  },
  {
    node: {
      id: '5634556040',
      role: 'owner',
      profile: null,
      organization: {
        id: '5637443039',
        name: 'Company 4',
      },
    },
  },
];

export const MOCK_OPENING_JOB = [
  {
    node: {
      id: '51539608756',
      status: VACANCY_STATUS.OPEN,
      title: 'Looking for motivated AB to shape offshore winds future',
      createdAt: '2022-02-20T11:57:35.879648Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607511',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[1].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet, consectetur adipiscing elit', 'sed do eiusmod tempor incididunt ut labore et dolore', 'Ut enim ad minim veniam'],
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      salaryFrom: 1000,
      salaryTo: 2000,
      vesselKind: MOCK_VESSEL_KINDS[0],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE,
      duration: DURATION_LIST_ENUMS.ONETERM,
      salaryPeriod: SALARY_PERIOD_ENUMS.MONTHLY,
      hiringArea: initialListOfHiringAreas[0],
      tornWeeksOff: 1,
      tornWeeksOn: 3,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingCondition: MOCK_STARTING_CONDITION[0].id,
      startingDate: null,
      hires: GET_LIST_OF_HIRES,
    },
  },
  {
    node: {
      id: '51539608784',
      status: VACANCY_STATUS.OPEN,
      title: 'Looking for motivated AB',
      createdAt: '2022-04-12T11:15:46.487825Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607512',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[1].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet, consectetur adipiscing', 'sed do eiusmod tempor incididunt ut labore', 'Ut enim ad minim veniam'],
      description: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
      salaryFrom: 1500,
      salaryTo: 2500,
      vesselKind: MOCK_VESSEL_KINDS[0],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE,
      duration: DURATION_LIST_ENUMS.ONETERM,
      salaryPeriod: SALARY_PERIOD_ENUMS.MONTHLY,
      hiringArea: initialListOfHiringAreas[0],
      tornWeeksOff: 2,
      tornWeeksOn: 3,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: '2028-06-24T11:15:46.487825Z',
      hires: GET_LIST_OF_HIRES,
    },
  },
  {
    node: {
      id: '51539608159',
      status: VACANCY_STATUS.OPEN,
      title: 'Looking for motivated AB to shape offshore winds future',
      createdAt: '2022-01-17T11:19:34.922664Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607513',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[1].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet, consectetur adipiscing elit', 'sed do eiusmod tempor incididunt ut labore et dolore', 'Ut enim ad minim veniam'],
      description: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text',
      salaryFrom: 2500,
      salaryTo: 3600,
      vesselKind: MOCK_VESSEL_KINDS[1],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.OFFSHORE_OIL_GAS,
      duration: DURATION_LIST_ENUMS.TEMPORARY,
      salaryPeriod: SALARY_PERIOD_ENUMS.DAILY,
      hiringArea: initialListOfHiringAreas[1],
      tornWeeksOff: 2,
      tornWeeksOn: 2,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: '2030-05-10T11:15:46.487825Z',
      hires: GET_LIST_OF_HIRES,
    },
  },
  {
    node: {
      id: '51539608357',
      status: VACANCY_STATUS.CLOSED,
      title: 'Looking for Chief Officer',
      createdAt: '2021-11-05T13:17:35.743698Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607514',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[1].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet', 'sed do eiusmod tempor incididunt', 'Ut enim ad minim veniam'],
      description: 'Contrary to popular belief, Lorem Ipsum is not simply random text.',
      salaryFrom: 5000,
      salaryTo: 10000,
      vesselKind: MOCK_VESSEL_KINDS[3],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE,
      duration: DURATION_LIST_ENUMS.ONETERM,
      salaryPeriod: SALARY_PERIOD_ENUMS.MONTHLY,
      hiringArea: initialListOfHiringAreas[2],
      tornWeeksOff: 4,
      tornWeeksOn: 4,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: null,
      hires: GET_LIST_OF_HIRES,
    },
  },
  {
    node: {
      id: '51539606548',
      status: VACANCY_STATUS.CLOSED,
      title: 'Looking for Chief Officer',
      createdAt: '2022-01-12T13:17:59.013574Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607515',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[2].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet, consectetur adipiscing elit', 'sed do eiusmod tempor incididunt ut labore et dolore'],
      description: 'The first line of Lorem Ipsum',
      salaryFrom: 1235,
      salaryTo: 2543,
      vesselKind: MOCK_VESSEL_KINDS[2],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND,
      duration: DURATION_LIST_ENUMS.TEMPORARY,
      salaryPeriod: SALARY_PERIOD_ENUMS.MONTHLY,
      hiringArea: initialListOfHiringAreas[1],
      tornWeeksOff: 2,
      tornWeeksOn: 5,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: '2026-10-02T11:15:46.487825Z',
    },
  },
  {
    node: {
      id: '51539684597',
      status: VACANCY_STATUS.CLOSED,
      title: 'Looking for Chief Officer',
      createdAt: '2022-01-12T13:17:59.013574Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607516',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[2].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Lorem ipsum dolor sit amet, consectetur adipiscing elit', 'sed do eiusmod tempor incididunt ut labore et dolore'],
      description: 'The first line of Lorem Ipsum',
      salaryFrom: 1235,
      salaryTo: 2543,
      vesselKind: MOCK_VESSEL_KINDS[1],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND,
      duration: DURATION_LIST_ENUMS.PERMANENT,
      salaryPeriod: SALARY_PERIOD_ENUMS.MONTHLY,
      hiringArea: initialListOfHiringAreas[0],
      tornWeeksOff: 1,
      tornWeeksOn: 2,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: '2055-06-31T11:15:46.487825Z',
    },
  },
  {
    node: {
      id: '51539633784',
      status: VACANCY_STATUS.OPEN,
      title: 'Looking for motivated AB',
      createdAt: '2022-04-12T11:15:46.487825Z',
      organization: {
        ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
        id: '51539607512',
      },
      organizationMember: MOCK_ORGANIZATION_MEMBERS[3].node,
      certificates: CERTIFICATES_WITH_ALL_ICONS_AND_WITH_EXPIRY_DATE.map(certificate => certificate.certificate),
      responsibilities: ['Find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?'],
      description: 'Et harum quidem rerum facilis est et expedita distinctio.',
      salaryFrom: 1100,
      salaryTo: 1300,
      vesselKind: MOCK_VESSEL_KINDS[0],
      duties: DUTIES_MOCK,
      industry: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND,
      duration: DURATION_LIST_ENUMS.TEMPORARY,
      salaryPeriod: SALARY_PERIOD_ENUMS.DAILY,
      hiringArea: initialListOfHiringAreas[1],
      tornWeeksOff: 3,
      tornWeeksOn: 1,
      invites: [],
      applications: [],
      currency: {
        id: '128849018881',
        name: 'USD',
        perma: '2',
      },
      startingDate: '2030-01-01T11:15:46.487825Z',
    },
  },
];

export const GET_CREW_APPLICATIONS = (organizationId: string) => [
  {
    node: {
      id: '115964117385',
      createdAt: '2023-01-25T11:08:00.18688Z',
      vacancy: {
        id: '90194313631',
        title: 'Position 1',
        organization: {
          id: organizationId,
        },
      },
    },
  },
  {
    node: {
      id: '115964117384',
      createdAt: '2023-01-25T11:07:56.294878Z',
      vacancy: {
        id: '90194313423',
        title: 'Position 2',
        organization: {
          id: organizationId,
        },
      },
    },
  },
  {
    node: {
      id: '115964117383',
      createdAt: '2023-01-25T11:07:55.33426Z',
      vacancy: {
        id: '90194313389',
        title: 'Position 3',
        organization: {
          id: organizationId,
        },
      },
    },
  },
  {
    node: {
      id: '115964117382',
      createdAt: '2023-01-25T11:07:54.395107Z',
      vacancy: {
        id: '90194313381',
        title: 'Position 4',
        organization: {
          id: organizationId,
        },
      },
    },
  },
  {
    node: {
      id: '115964117381',
      createdAt: '2023-01-25T11:07:53.591202Z',
      vacancy: {
        id: '90194313374',
        title: 'Position 5',
        organization: {
          id: organizationId,
        },
      },
    },
  },
];

export const JOB_OPENING_WITH_OPEN_STATUS = MOCK_OPENING_JOB.filter(vacancy => vacancy.node.status === VACANCY_STATUS.OPEN);
export const JOB_OPENING_WITH_CLOSED_STATUS = MOCK_OPENING_JOB.filter(vacancy => vacancy.node.status === VACANCY_STATUS.CLOSED);

export const JOB_OPENING_WITH_OPEN_STATUS_AND_WITH_APPLICATIONS = (generateId: () => number) =>
  JOB_OPENING_WITH_OPEN_STATUS.map((vacancyNode, index) => ({
    node: {
      ...vacancyNode.node,
      id: `1454587252${generateId()}`,
      applications: new Array(5).fill({}).map(() => ({
        id: `1458741252${generateId()}`,
        owner: { id: `5478412581${generateId()}`, info: { avatarUrl: MOCK_AVATAR } },
        status: index % 2 === 0 ? VACANCY_APPLICATION_STATUS.PENDING : VACANCY_APPLICATION_STATUS.DECLINED,
      })),
    },
  }));

export const JOB_OPENING_WITH_NODE = JOB_OPENING_WITH_OPEN_STATUS.map(vacancy => vacancy.node);

export const JOB_OPENING_SEARCH_CONNECTION = JOB_OPENING_WITH_OPEN_STATUS.map(vacancy => ({
  node: { ...vacancy.node, objectID: vacancy.node.id },
}));

export const ORGANISATIONS_SEARCH_CONNECTION = [
  { node: { objectID: '6453789475' } },
  { node: { objectID: '6453745475' } },
  { node: { objectID: '6453234475' } },
  { node: { objectID: '6453795475' } },
  { node: { objectID: '6649389475' } },
  { node: { objectID: '6450048475' } },
  { node: { objectID: '6453795332' } },
  { node: { objectID: '6649389534' } },
  { node: { objectID: '6450048935' } },
];

export const ORGANISATIONS_SEARCH_CONNECTION_FOR_NAVBAR = ORGANISATIONS_SEARCH_CONNECTION.slice(0, 3);

export const MOCK_LIST_OF_ORGANISATIONS = ORGANISATIONS_SEARCH_CONNECTION.slice(0, 3).map((org, index) => ({
  ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
  id: org.node.objectID,
  numberOfVacancies: index % 2 ? 0 : MEMBERSHIP_ORGANIZATION_MOCK.organization.numberOfVacancies,
}));

export const MOCK_LIST_OF_ORGANISATIONS_WITHOUT_AVATARS = ORGANISATIONS_SEARCH_CONNECTION.slice(0, 3).map((org, index) => ({
  ...MEMBERSHIP_ORGANIZATION_MOCK.organization,
  id: org.node.objectID,
  numberOfVacancies: index % 2 ? 0 : MEMBERSHIP_ORGANIZATION_MOCK.organization.numberOfVacancies,
  avatarUrl: null,
}));

export const JOB_OPENING_WITH_OPEN_STATUS_AND_WITHOUT_AVATAR = JOB_OPENING_WITH_OPEN_STATUS.map(vacancy => ({
  node: { ...vacancy.node, organization: { ...vacancy.node.organization, avatarUrl: null } },
}));

export const JOB_OPENING_FORM_STEPS: Array<JobOpeningFormStepType> = [
  {
    path: RoutePaths.JobOpeningStep1,
    step: 1,
    title: { id: 'hire_form_general_step_1_title' },
    bigTitle: { id: 'hire_form_step_1_title' },
    current: false,
    active: false,
  },
  {
    path: RoutePaths.JobOpeningStep2,
    step: 2,
    title: { id: 'hire_form_general_step_2_title' },
    bigTitle: { id: 'hire_form_step_2_title' },
    current: false,
    active: false,
  },
  {
    path: RoutePaths.JobOpeningStep3,
    step: 3,
    title: { id: 'hire_form_general_step_3_title' },
    bigTitle: { id: 'hire_form_step_3_title' },
    current: false,
    active: false,
  },
];

export const GET_SIMPLE_VACANCY = {
  id: '90194313314',
  title: 'Captain',
  organization: {
    id: '51539607562',
  },
  organizationMember: MOCK_ORGANIZATION_MEMBERS[2].node,
};

export const MOCK_SALARY_PERIOD: Array<SALARY_PERIOD_TYPE> = [
  { name: 'Monthly', id: SALARY_PERIOD_ENUMS.MONTHLY },
  { name: 'Weekly', id: SALARY_PERIOD_ENUMS.WEEKLY },
  { name: 'Daily', id: SALARY_PERIOD_ENUMS.DAILY },
];

export const MOCK_INDUSTRY_LIST: Array<INDUSTRY_LIST> = [
  { id: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE, title: 'hire_information_industry_nautical_worldwide', SvgComponent: ShipToggle, helperText: '' },
  { id: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND, title: 'hire_information_industry_offshore_wind', SvgComponent: WindMillToggle, helperText: '' },
  { id: INDUSTRY_LIST_ENUMS.OFFSHORE_OIL_GAS, title: 'hire_information_industry_offshore_oil_gas', SvgComponent: GasStationToggle, helperText: '' },
];

export const MOCK_LIST_OF_INDUSTRIES: Array<SelectedFilterElementsType> = [
  { id: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE, key: INDUSTRY_LIST_ENUMS.NAUTICAL_WORLDWIDE, name: 'Nautical worldwide' },
  { id: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND, key: INDUSTRY_LIST_ENUMS.OFFSHORE_WIND, name: 'Offshore wind' },
  { id: INDUSTRY_LIST_ENUMS.OFFSHORE_OIL_GAS, key: INDUSTRY_LIST_ENUMS.OFFSHORE_OIL_GAS, name: 'Offshore oil & gas' },
];

export const MOCK_DURATION_OF_POSITION_WITH_NAME: Array<SelectedFilterElementsType> = [
  { id: DURATION_LIST_ENUMS.ONETERM, key: DURATION_LIST_ENUMS.ONETERM, name: 'One term' },
  { id: DURATION_LIST_ENUMS.TEMPORARY, key: DURATION_LIST_ENUMS.TEMPORARY, name: 'Temporary' },
  { id: DURATION_LIST_ENUMS.PERMANENT, key: DURATION_LIST_ENUMS.PERMANENT, name: 'Permanent' },
];

export const MOCK_AVAILABLE_FOR_WORK = [{ name: 'Available for work', id: FILTER_BOOLEAN_ID.AVAILABLE_FOR_WORK }];

export const MOCK_DURATION_OF_POSITION: Array<DURATION_LIST> = [
  { id: DURATION_LIST_ENUMS.ONETERM, title: 'hire_information_duration_one_term', SvgComponent: OneTermToggle },
  { id: DURATION_LIST_ENUMS.TEMPORARY, title: 'hire_information_duration_temporary', SvgComponent: TemporaryToggle },
  { id: DURATION_LIST_ENUMS.PERMANENT, title: 'hire_information_duration_permanent', SvgComponent: PermanentToggle },
];

export const MOCK_ITEMS_STORIES_HIRECARDINFORMATION = [
  { id: DURATION_LIST_ENUMS.ONETERM, title: 'hire_information_duration_one_term', SvgComponent: OneTermToggle, helperText: '' },
  { id: DURATION_LIST_ENUMS.TEMPORARY, title: 'hire_information_duration_temporary', SvgComponent: TemporaryToggle, helperText: '' },
  { id: DURATION_LIST_ENUMS.PERMANENT, title: 'hire_information_duration_permanent', SvgComponent: PermanentToggle, helperText: '' },
];

export const GetPopoverProfileRatingButtons: (navigate: NavigateFunction, currentPathname: string) => profileScoreDetailsInfoType = navigate => ({
  basic_info: {
    icon: AccountCircleIcon,
    label: { id: 'rating_fill_form' },
    onClick: () => {
      navigate(RoutesPathNames.editProfileInfo);
    },
  },
  exists_bio: {
    icon: AccountCircleIcon,
    label: { id: 'rating_fill_form_add_bio' },
    onClick: () => {
      navigate(RoutesPathNames.editProfileInfo);
    },
  },
  one_sea_service: {
    label: { id: 'rating_add_sea_services' },
    icon: BusinessCenterIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseSeaServices, {
        state: {
          flickeringModalOpenButton: true,
        },
      });
    },
  },
  one_certificate: {
    label: { id: 'rating_add_certificates' },
    icon: ArticleIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseCertificates, {
        state: {
          flickeringModalOpenButton: true,
        },
      });
    },
  },
  one_education: {
    label: { id: 'rating_add_education' },
    icon: SchoolIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseEducation, {
        state: {
          flickeringModalOpenButton: true,
        },
      });
    },
  },
  one_appraisal: {
    label: { id: 'rating_add_appraisals' },
    icon: ContactPageIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseAppraisals, {
        state: {
          flickeringModalOpenButton: true,
        },
      });
    },
  },
  all_certs_has_expire_date: {
    label: { id: 'rating_add_certs_expiry_date' },
    icon: ArticleIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseCertificates, {
        state: {
          addExpiryDate: true,
        },
      });
    },
  },
  all_certs_has_documents: {
    label: { id: 'rating_add_certs_documents' },
    icon: ArticleIcon,
    onClick: () => {
      navigate(RoutesPathNames.ProfileBaseCertificates, {
        state: {
          attachFile: true,
        },
      });
    },
  },
  exists_avatar: {
    label: { id: 'rating_add_avatar' },
    icon: AccountCircleIcon,
    onClick: () => {
      navigate(RoutesPathNames.editProfileInfo);
    },
  },
});

export const MOCK_VACANCY_INVITES = [
  { id: '120259084288', owner: { id: '30064771072' } },
  { id: '120259084289', owner: { id: '98784247811' } },
];

export const MOCK_VACANCY_APPLICATIONS = [{ id: '120259084283', owner: { id: '30064771073' } }];

export const MOCK_LIST_OF_VACANCIES = [
  { id: '128849018880', name: 'USD', perma: '1' },
  { id: '128849018881', name: 'EUR', perma: '2' },
];

export const VACANCY_ERRORS: VacancyErrorsTypes = {
  ErrVacancyNotOpen: { modalTitle: { id: 'error_vacancy_closed' } },
};
export const searchUrlParams = {
  [FILTER_TYPE.CERTIFICATES]: `${PROFILE_CERTIFICATE_MOCK_DATA[0].id},${PROFILE_CERTIFICATE_MOCK_DATA[3].id}`,
  [FILTER_TYPE.DUTIES]: `${DUTIES_MOCK[0].id},${DUTIES_MOCK[2].id},${DUTIES_MOCK[1].id}`,
  [FILTER_TYPE.PRIMARY_DUTIES]: `${DUTIES_MOCK[1].id},${DUTIES_MOCK[0].id},${DUTIES_MOCK[2].id}`,
  [FILTER_TYPE.MOST_RECENT_SERVICE_DUTY]: `${DUTIES_MOCK[2].id},${DUTIES_MOCK[0].id}`,
  [FILTER_TYPE.COUNTRIES]: `${initialListOfCountries[2].isoCode},${initialListOfCountries[4].isoCode},${initialListOfCountries[1].isoCode}`,
  [FILTER_TYPE.EDUCATION]: `${EDUCATION_KINDS_MOCK_DATA[1].id}`,
  [FILTER_TYPE.ACTIVITIES]: `${TAGS_MOCK[0].id},${TAGS_MOCK[1].id}`,
  [FILTER_TYPE.VESSEL_TYPES]: `${MOCK_VESSEL_KINDS[0].id}`,
  [FILTER_TYPE.NUMBER_OF_APPRAISALS_FROM]: '1',
  [FILTER_TYPE.NUMBER_OF_APPRAISALS_TO]: '2',
  [FILTER_TYPE.NUMBER_OF_EXPERIENCE_FROM]: '1',
  [FILTER_TYPE.NUMBER_OF_EXPERIENCE_TO]: '3',
  [FILTER_TYPE.NUMBER_OF_SEA_SERVICES_FROM]: '2',
  [FILTER_TYPE.NUMBER_OF_SEA_SERVICES_TO]: '3',
  [FILTER_TYPE.WORKED_FOR]: 'Ship',
  [FILTER_TYPE.CREW_VESSEL_IMO]: '1000007',
};

export const searchJobOpeningUrlParams = {
  [FILTER_TYPE.HIRING_AREA]: `${initialListOfHiringAreas[1].id},${initialListOfHiringAreas[2].id}`,
  [FILTER_TYPE.INDUSTRY]: `${MOCK_LIST_OF_INDUSTRIES[0].id},${MOCK_LIST_OF_INDUSTRIES[1].id}`,
  [FILTER_TYPE.NUMBER_OF_MIN_SALARY]: '1000',
  [FILTER_TYPE.SALARY_PERIOD]: MOCK_SALARY_PERIOD[0].id,
  [FILTER_TYPE.DUTIES]: MOCK_SINGLE_DUTY.id,
  [FILTER_TYPE.VESSEL_TYPES]: MOCK_VESSEL_KINDS[0].id,
  [FILTER_TYPE.DURATION]: DURATION_LIST_ENUMS.ONETERM,
  [FILTER_TYPE.STARTING_CONDITIONAL]: MOCK_STARTING_CONDITION[0].id,
  [FILTER_TYPE.STARTING_DATE]: '2022-12-11T22:00:00.000Z',
};

export const listOfAppliedCrewFilterParams = ['Invited', 'Uninvited'];

export const notificationPreferences = [
  { id: NOTIFICATION_PREFERENCE.jobOpeningNotifications, label: 'job_openings_notification_label', description: 'job_openings_notification_description' },
  { id: NOTIFICATION_PREFERENCE.tipsToImproveNotifications, label: 'tips_notification_label', description: 'tips_notification_description' },
];

export const DASHBOARD_TABLE_TABS: ButtonsTabType = [
  { id: DASHBOARD_TABS_ID.OPENED_TAB, title: 'hire_dashboard_header_tabs_show_open' },
  { id: DASHBOARD_TABS_ID.SHOW_ALL_TAB, title: 'hire_dashboard_header_tabs_show_all' },
];

export const tableCellWidth = {
  number: 'w-5%',
  status: 'w-[7%]',
  positionTitle: 'w-[18%]',
  position: 'w-[13%]',
  vesselType: 'w-15',
  salaryRange: 'w-10%',
  industry: 'w-10%',
  applied: 'w-[7%]',
  postingDate: 'w-10%',
  emptyTitle: 'w-5%',
};

export const numberOfYearsOfExperience = [
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_0_1, name: '0-1 years' },
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_1_2, name: '1-2 years' },
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_2_5, name: '2-5 years' },
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_5_10, name: '5-10 years' },
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_10_20, name: '10-20 years' },
  { id: SIGN_UP_STEP_WITH_USER_EXPERIENCE.YEARS_MORE_20, name: '20+ years' },
];
export const MOCK_HIRE_PROFILE_CREW_POOLS = [
  {
    node: {
      name: 'Riggers',
      id: '146028888160',
      kind: 'REGULAR',
      CreatedAt: '2023-05-12T12:18:58.586897Z',
      UpdatedAt: '2023-05-12T12:18:58.586898Z',
    },
  },
  {
    node: {
      name: '3d officers',
      id: '146028888161',
      kind: 'REGULAR',
      CreatedAt: '2023-05-12T12:19:05.612532Z',
      UpdatedAt: '2023-05-12T12:19:05.612533Z',
    },
  },
  {
    node: {
      name: 'Officers',
      id: '146028888162',
      kind: 'REGULAR',
      CreatedAt: '2023-05-12T12:19:14.285334Z',
      UpdatedAt: '2023-05-12T12:19:14.285335Z',
    },
  },
];
export const MOCK_HIRE_CREW_POOL_STATS = [
  {
    id: MOCK_HIRE_PROFILE_CREW_POOLS[0].node.id,
    totalCrewCount: 2,
    availableCrewCount: 1,
    crewPoolAvatars: [MOCK_AVATAR, '', MOCK_AVATAR],
  },
  {
    id: MOCK_HIRE_PROFILE_CREW_POOLS[2].node.id,
    totalCrewCount: 3,
    availableCrewCount: 2,
    crewPoolAvatars: [MOCK_AVATAR, MOCK_AVATAR],
  },
];

export const PROFILE_CONNECTION_MOCK_PROFILES = [
  {
    node: {
      id: '98784247811',
      info: {
        id: '103079215104',
        primaryDuty: {
          id: '17179869207',
        },
        firstName: 'Adam',
        lastName: 'van der Veer',
        birthDate: '1989-06-15T22:00:00Z',
        country: {
          isoCode: initialListOfCountries[0].isoCode,
        },
        avatarUrl: '',
      },
      certificateInfos: [
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[0].id,
          },
        },
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[1].id,
          },
        },
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[2].id,
          },
        },
      ],
      seaServices: [
        {
          id: '128849018880',
          start: '2016-07-04T11:26:54Z',
          end: '2019-07-04T11:26:54Z',
          duty: {
            id: DUTIES_MOCK[0].id,
          },
          activities: [
            {
              id: TAGS_MOCK[0].id,
            },
          ],
        },
        {
          id: '128849018904',
          start: '2020-07-04T10:56:04Z',
          end: '2023-07-04T10:56:04.977Z',
          duty: {
            id: DUTIES_MOCK[1].id,
          },
          activities: [
            {
              id: TAGS_MOCK[1].id,
            },
          ],
        },
      ],
    },
  },

  {
    node: {
      id: '98784247808',
      info: {
        id: '103079215111',
        primaryDuty: {
          id: DUTIES_MOCK[2].id,
        },
        firstName: 'Christopher',
        lastName: 'Columbus',
        birthDate: '1989-06-15T22:00:00Z',
        country: {
          isoCode: initialListOfCountries[1].isoCode,
        },
        avatarUrl: '',
      },
      certificateInfos: [
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[2].id,
          },
        },
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[1].id,
          },
        },
        {
          certificate: {
            id: PROFILE_CERTIFICATE_MOCK_DATA[3].id,
          },
        },
      ],
      seaServices: [
        {
          id: '128849018880',
          start: '2015-07-05T12:20:34Z',
          end: '2016-07-05T12:20:34Z',
          duty: {
            id: DUTIES_MOCK[1].id,
          },
          activities: [
            {
              id: TAGS_MOCK[2].id,
            },
          ],
        },
        {
          id: '128849018904',
          start: '2022-07-04T10:56:04Z',
          end: '2017-07-04T10:56:04.977Z',
          duty: {
            id: DUTIES_MOCK[0].id,
          },
          activities: [
            {
              id: TAGS_MOCK[2].id,
            },
          ],
        },
      ],
    },
  },
];

export const PROFILE_ORG_MEMBERS_CONNECTION_MOCK_PROFILES = [
  {
    node: {
      id: '5634268908',
      profile: {
        id: '98784247301',
        seaServices: SEA_SERVICE_MOCK_DATA,
        educations: [{ id: '101' }, { id: '102' }],
        certificateInfos: [{ id: '111' }, { id: '112' }, { id: '113' }, { id: '114' }],
        info: {
          avatarUrl: '',
          primaryDuty: DUTIES_MOCK[0],
          country: initialListOfCountries[1],
          birthDate: '2000-12-11T21:00:00Z',
          firstName: 'Oleksandr',
          lastName: 'Serhiienko',
        },
      },
      organization: {
        id: '',
        avatarUrl: '',
        name: 'Ship corp.',
      },
      role: 'member',
    },
  },
  {
    node: {
      id: '98784247822',
      profile: {
        id: '98784247330',
        seaServices: SEA_SERVICE_MOCK_DATA,
        educations: [{ id: '101' }, { id: '102' }],
        certificateInfos: [{ id: '111' }, { id: '112' }, { id: '113' }],
        info: {
          avatarUrl: MOCK_AVATAR,
          country: initialListOfCountries[3],
          birthDate: '1998-12-11T21:00:00Z',
          primaryDuty: DUTIES_MOCK[0],
          firstName: 'Adam',
          lastName: 'van der Veer',
        },
      },
      organization: {
        id: '',
        avatarUrl: '',
        name: 'Ship corp.',
      },
      role: 'member',
    },
  },
  {
    node: {
      id: '98784247801',
      profile: {
        id: '98784247355',
        seaServices: SEA_SERVICE_MOCK_DATA,
        educations: [{ id: '101' }],
        certificateInfos: [{ id: '111' }, { id: '112' }, { id: '113' }],
        info: {
          avatarUrl: '',
          country: initialListOfCountries[2],
          birthDate: '1992-12-11T21:00:00Z',
          primaryDuty: DUTIES_MOCK[1],
          firstName: 'Christopher',
          lastName: 'Columbus',
        },
      },
      organization: {
        id: '',
        avatarUrl: 'https://clawssi-uploadsbucket-11va5m3jlet8r.s3.eu-west-1.amazonaws.com/avatars/1fd51a0aedc8be2bf73f4fe2f75e5e96_xs.png',
        name: 'Ship corp.',
      },
      role: 'owner',
    },
  },
  {
    node: {
      id: '98784247802',
      profile: {
        id: '98784247356',
        seaServices: SEA_SERVICE_MOCK_DATA,
        educations: [{ id: '101' }, { id: '102' }, { id: '103' }, { id: '104' }],
        certificateInfos: [{ id: '111' }, { id: '112' }, { id: '113' }],
        info: {
          avatarUrl: '',
          country: initialListOfCountries[0],
          birthDate: '1990-12-11T21:00:00Z',
          primaryDuty: DUTIES_MOCK[2],
          firstName: 'Chris',
          lastName: 'Jackson',
        },
      },
      organization: {
        id: '00000000111',
        avatarUrl: 'https://clawssi-uploadsbucket-11va5m3jlet8r.s3.eu-west-1.amazonaws.com/avatars/1fd51a0aedc8be2bf73f4fe2f75e5e96_xs.png',
        name: 'Ship React corp.',
      },
      role: 'invited',
    },
  },
  {
    node: {
      id: '98784247803',
      profile: {
        id: '98784247357',
        seaServices: [SEA_SERVICE_MOCK_DATA[0]],
        certificateInfos: [{ id: '111' }],
        educations: [{ id: '101' }],
        info: {
          avatarUrl: '',
          country: initialListOfCountries[1],
          birthDate: '1989-06-15T22:00:00Z',
          primaryDuty: DUTIES_MOCK[0],
          firstName: 'Joan',
          lastName: 'Robinson',
        },
      },
      organization: {
        id: '00000000112',
        avatarUrl: '',
        name: 'Cargo Fast corp.',
      },
      role: 'invited',
    },
  },
];
